<!--  -->
<template>
    <div class="gardenContentEdit">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="104px">
            <div class="bgc box-shadow padding-20">
                <div class="warning_msg"><i class="el-icon-warning"></i>请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。</div>
                <el-form-item label="内容标题" prop="subject">
                    <el-input :disabled="disabled" class="width810" v-model="form.subject" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="所属板块" prop="columncode">
                    <el-select :disabled="disabled" class="width440" v-model="form.columncode" placeholder="所属板块">
                        <el-option v-for="(item, index) in panelnameList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="封面图片" prop="coverurl" class="coverurl">
                    <div class="content">
                        <div class="left_img">
                            <i class="el-icon-picture" v-if="!form.coverurl"></i>
                            <img v-else :src="form.coverurl + '?' + time" alt="">
                            <img class="close" @click="deleteCoverurl" v-if="form.coverurl" :src="require('@/common/images/cms/close.png')" alt="">
                        </div>
                        <div class="right_btn">
                            <div class="btn">
                                <UploadFile :fileRule="fileRule" :uploadType="uploadType" @setFile="getCoverurl" />
                                <el-button :disabled="disabled" type="warning" @click="openCoverScrollBox">素材库</el-button>
                            </div>
                            <p class="tips">建议尺寸750*422px或16:9，JPG、PNG格式， 图片小于5M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="内容标签">
                    <el-input class="width440" :disabled="disabled" v-model="form.tagsname" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否推荐" class="isrecommend">
                    <el-radio-group :disabled="disabled" v-model="form.isrecommend">
                        <el-radio :label="1">推荐</el-radio>
                        <el-radio :label="0">不推荐</el-radio>
                    </el-radio-group>
                    <p class="tips">推荐后会显示在列表前面</p>
                </el-form-item>
                <el-form-item label="发布日期" prop="releasetime">
                    <el-date-picker :disabled="disabled" class="width440" v-model="form.releasetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="内容关键字">
                    <el-input class="width440" placeholder="请填写内容关键字" :disabled="disabled" v-model="form.keyname" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="链接类型" class="isrecommend" prop="urltype">
                    <el-radio-group :disabled="disabled" v-model="form.urltype">
                        <el-radio :label="1">自有内容</el-radio>
                        <el-radio :label="2">第三方内容</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="链接Url" v-if="form.urltype === 2" prop="linkurl">
                    <el-input :disabled="disabled" class="width440" v-model="form.linkurl" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="内容正文">
                    <uEditor :content="form.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
                </el-form-item>
            </div>
            <div class="btn bgc box-shadow padding-20">
                <el-button type="primary" @click="submit(0)" v-if="!disabled">发布</el-button>
                <el-button type="warning" @click="submit(1)" v-if="!form.innerid || (form.innerid && form.status === 0)">存至草稿</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </div>
        </el-form>
        <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="getCoverurl"></scrollBox>
    </div>
</template>

<script>
import ScrollBox from '@/base/scrollBox/scrollBox'
import UEditor from 'base/uEditor/uEditor3'
import UploadFile from '@/base/upload/uploadFile2'
import {mapActions, mapGetters} from 'vuex'
import {uploadGovparkcontentinfo, getGovparkcontentinfo} from 'api/gardenApi'
export default {
    data() {
        return {
            form: {
                subject: '', // 内容标题
                columnname: '', // 所属板块名称
                columncode: '', // 所属板块code
                content: '', // 资讯内容
                coverid: '', // 封面图id
                coverurl: '', // 封面图url
                innerid: this.$route.query.innerid ? this.$route.query.innerid : '', // 内容id
                isrecommend: 0, // 是否推荐 0否1是
                keyname: '', // 关键字
                linkurl: '', // 链接地址
                parkinnerid: this.$route.query.parkinnerid, // 园区id
                releasetime: '', // 发布日期
                tagsname: '', // 内容标签
                urltype: 1, // 链接类型 1自由资讯 2第三方url
                isdraft: 0 // 是否是草稿
            },
            rules: {
                subject: [
                    {required: true, message: '请输入内容标题', trigger: 'blur'}
                ],
                columncode: [
                    {required: true, message: '请选择所属板块', trigger: 'blur'}
                ],
                coverurl: [
                    {required: true, message: '请上传封面图片', trigger: 'blur'}
                ],
                releasetime: [
                    {required: true, message: '请选择发布日期', trigger: 'blur'}
                ],
                urltype: [
                    {required: true, message: '请选择链接类型', trigger: 'blur'}
                ],
                linkurl: [
                    {required: true, message: '请输入链接地址', trigger: 'blur'}
                ]
            },
            panelnameList: [
                {label: '明星企业', value: '1'},
                {label: '营商环境', value: '2'},
                {label: '区域政策', value: '3'}
            ],
            time: new Date().getTime(),
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 750,
                height: 422,
                nottype: true
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            disabled: false
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.innerid) {
            this.getGovparkcontentinfo()
        } else {
            this.form.releasetime = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        deleteCoverurl() {
            if (!this.disabled) {
                this.form.coverurl = ''
                this.form.coverid = ''
            }
        },
        getCoverurl(file) {
            if (!this.disabled) {
                this.form.coverurl = file.furl
                this.form.coverid = file.key
                this.time = new Date().getTime()
            }
        },
        handleCancel() {
            this.$router.back(1)
        },
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        getUEditorContent(content) {
            if (!this.disabled) {
                this.form.content = content
            }
        },
        submit(isdraft) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.setLoading(true)
                    this.form.isdraft = isdraft
                    if (this.form.columncode) {
                        this.panelnameList.some(item => {
                            if (item.value === this.form.columncode) {
                                this.form.columnname = item.label
                            }
                        })
                    }
                    uploadGovparkcontentinfo({
                        data: this.form,
                        success: res => {
                            this.setLoading(false)
                            this.$router.push({name: 'GardenContentList', query: {parkinnerid: this.form.parkinnerid, name: this.$route.query.name}})
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    this.$message.error('请完善您的数据')
                }
            })
        },
        getGovparkcontentinfo() {
            this.setLoading(true)
            getGovparkcontentinfo({
                data: {innerid: this.form.innerid},
                success: res => {
                    this.setLoading(false)
                    this.form = res.data
                    if (this.form.status === 100 && !this.$route.query.iscopy) {
                        this.disabled = true
                    }
                    if (this.$route.query.iscopy) {
                        this.form.innerid = ''
                    }
                    if (this.form.content) {
                        this.$refs.uEditor.init(this.form.content)
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    components: {
        ScrollBox,
        UEditor,
        UploadFile
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .gardenContentEdit {
        .warning_msg {
            padding: 12px 10px;
            background: #FDF6EC;
            color: #E6A23C;
            font-size: 14px;
            margin-bottom: 20px;
            border-radius: 4px;
            .el-icon-warning {
                margin-right: 10px;
            }
        }
        .el-form {
            padding-left: 10px;
            .el-form-item {
                padding-left: 10px;
                .el-form-item__label {
                    text-align: left;
                }
                .width810 {
                    width: 810px;
                }
                .width440 {
                    width: 440px;
                }
                .el-select {
                    .el-select__caret {
                        line-height: 32px;
                    }
                }
            }
            .coverurl {
                .el-form-item__label {
                    line-height: 20px;
                }
                .content {
                    display: flex;
                    align-items: center;
                    .left_img {
                        width: 318px;
                        height: 178px;
                        margin-right: 12px;
                        background: #F5F7FA;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 38px;
                        color: #DCDFE6;
                        position: relative;
                        img {
                            width: 318px;
                            height: 178px;
                            border-radius: 4px;
                        }
                        .close {
                            width: 20px;
                            height: 20px;
                            position: absolute;
                            top: -10px;
                            right: -10px;
                        }
                    }
                    .right_btn {
                        .btn {
                            display: flex;
                            align-items: center;
                            margin-bottom: 12px;
                            justify-content: flex-start;
                            .el-button--warning {
                                margin-left: 20px;
                            }
                        }
                        .tips {
                            font-size: 14px;
                            color: #C0C4CC;
                            line-height: 20px;
                        }
                    }
                }
            }
            .isrecommend {
                .is-checked {
                    .el-radio__label {
                        color: #303133;
                    }
                }
                .tips {
                    color: #999999;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
            .btn {
                margin-top: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                .el-button--primary {
                    margin-right: 32px;
                }
                .el-button--warning {
                    margin-left: 0;
                    margin-right: 32px;
                }
                .el-button--default {
                    margin-left: 0;
                }
            }
            .is-required {
                .el-form-item__label::before {
                    content: '';
                    display: none;
                }
                .el-form-item__label::after {
                    content: '*';
                    color: #F56C6C;
                    margin-right: 4px;
                }
            }
        }
    }
</style>